import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { withLocalize } from "react-localize-redux";

class Language extends Component {
    render() {
        // var active = "";
        // if (this.props.activeLanguage.code === this.props.code)
        //     active = "active";
        return (
            <button className={"dropdown-item "}
                onClick={() => this.props.setActiveLanguage(this.props.code)}>
                <Translate id={this.props.language} />
            </button>
        );
    }
}

export default withLocalize(Language);